import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetUsersListByCourse = (
  courseId,
  roleType,
  { page = 1, limit = 10000 } = {}
) => {
  const offset = (page - 1) * limit
  const endpoint = `/courses/${courseId}/enrollments?limit=${limit}&offset=${offset}&filter[role][type]=${roleType}&include=user`

  const query = useApiQuery(
    ['users-list-by-course', courseId, roleType, page, limit],
    'schools',
    async client => {
      const response = await client.get(endpoint)
      return {
        usersList: response.data,
        usersTotalCount: Number(
          response.headers['x-total-count'] ??
            (Array.isArray(response.data) ? response.data.length : 0)
        )
      }
    },
    {
      enabled: !!courseId && !!roleType,
      placeholderData: previousData => previousData
    },
    { authenticated: true, version: 4 }
  )

  return {
    usersList: query.isError ? null : query.data?.usersList ?? [],
    isLoadingUsers: query.isLoading || query.isFetching,
    usersTotalCount: query.isError ? null : query.data?.usersTotalCount ?? null,
    errorUsersList: query.isError ? query.error?.response ?? query.error : null,
    getUsersList: query.refetch
  }
}
